module.exports = __webpack_public_path__ + "static/img/checkmark-with-double-circle.df661d30.svg";